import "./Recordings.module.css";
import Header from "@/reusable_sections/Header";
import ExploreOurTeachings from "./sections/ExploreOurTeachings";
import FeaturedRetreatRecordings from "./sections/FeaturedRetreatRecordings";
import RecordedTeachings from "./sections/RecordedTeachings";
import Footer from "@/reusable_sections/Footer";
export default function RecordingsPage() {
  return <div>
      <Header />
      <ExploreOurTeachings />
      <FeaturedRetreatRecordings />
      <RecordedTeachings />
      <Footer />
    </div>;
}